import { z } from "zod";
export const FlashcardKindSchema = z.enum([
    "meaning_recall",
    "word_recall",
    "active_recall",
    "speaking_context",
    "chunk_production",
]);
export const FlashcardStateSchema = z.enum(["new", "learning", "review", "relearning"]);
export const RatingSchema = z.enum(["again", "hard", "good", "easy"]);
export const FlashcardSchema = z.object({
    id: z.string().uuid(),
    entry_id: z.string().uuid(),
    kind: FlashcardKindSchema,
    enabled: z.boolean(),
    front: z.string(),
    back: z.string(),
    due: z.string().datetime(),
    stability: z.number(),
    difficulty: z.number(),
    elapsed_days: z.number().int(),
    scheduled_days: z.number().int(),
    reps: z.number().int(),
    lapses: z.number().int(),
    state: FlashcardStateSchema,
    last_review: z.string().datetime().nullable(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const IntervalPreviewSchema = z.object({
    due: z.string().datetime(),
    label: z.string(),
});
export const FlashcardWithPreviewSchema = FlashcardSchema.extend({
    entry: z.object({
        word: z.string(),
        tags: z.array(z.string()),
        audio_url: z.string().url().optional(),
    }),
    expected_answer: z.string().optional(),
    next_intervals: z.object({
        again: IntervalPreviewSchema,
        hard: IntervalPreviewSchema,
        good: IntervalPreviewSchema,
        easy: IntervalPreviewSchema,
    }),
});
export const DueFlashcardsQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
export const DueFlashcardsResponseSchema = z.object({
    items: z.array(FlashcardWithPreviewSchema),
    due_count: z.number().int().nonnegative(),
});
export const ReviewFlashcardRequestSchema = z.object({
    rating: RatingSchema,
});
export const ReviewFlashcardResponseSchema = FlashcardSchema;
//# sourceMappingURL=flashcards.js.map